window.PRODUCTS=[
{
"h": "olivo",
"t": "Olivo",
"k": "pala",
"price": 230.0,
"img": [
"img__p__olivo_0.webp",
"img__p__olivo_1.webp",
"img__p__olivo_2.webp",
"img__p__olivo_3.webp",
"img__p__olivo_4.webp"
],
"v": [
{
"id": 52659740967254,
"t": "Hombre · 355-375 g",
"ok": true
},
{
"id": 52659740934486,
"t": "Mujer · 345-355 g",
"ok": true
}
],
"sub": "Carbono 3K · Core EVA · Hecha a mano en España",
"coll": "",
"soldout": false,
"tag": "Potencia con control",
"dureza": "Medio-dura",
"balance": "Medio (26 cm)",
"scores": {
"control": 85,
"manejo": 80,
"potencia": 90,
"dureza": 85,
"dulce": 75
},
"para": "Para quien busca un plus de potencia sin renunciar al control. Mantiene el control de una pala blanda y añade un punto de agresividad a tus tiros.",
"img_cut": "img__l__head-olivo.webp"
},
{
"h": "tinto",
"t": "Tinto",
"k": "pala",
"price": 230.0,
"img": [
"img__p__tinto_0.webp",
"img__p__tinto_1.webp",
"img__p__tinto_2.webp",
"img__p__tinto_3.webp",
"img__p__tinto_4.webp"
],
"v": [
{
"id": 52659747193174,
"t": "Hombre · 355-375 g",
"ok": true
},
{
"id": 52659747160406,
"t": "Mujer · 345-355 g",
"ok": false
}
],
"sub": "Carbono 3K · Core EVA · Hecha a mano en España",
"coll": "",
"soldout": false,
"tag": "Polivalente",
"dureza": "Media",
"balance": "Medio (26 cm)",
"badge": "Más vendida",
"scores": {
"control": 90,
"manejo": 90,
"potencia": 80,
"dureza": 75,
"dulce": 95
},
"para": "Para quien quiere hacerlo todo bien: defender, volear, buenas bandejas y control en los globos. No es una pala de potencia, pero sorprende su salida de bola.",
"img_cut": "img__l__head-tinto.webp"
},
{
"h": "la-blanca",
"t": "La Blanca",
"k": "pala",
"price": 230.0,
"img": [
"img__p__la-blanca_0.webp",
"img__p__la-blanca_1.webp",
"img__p__la-blanca_2.webp",
"img__p__la-blanca_3.webp",
"img__p__la-blanca_4.webp"
],
"v": [
{
"id": 52659747946838,
"t": "Hombre · 355-375 g",
"ok": true
},
{
"id": 52659747914070,
"t": "Mujer · 345-355 g",
"ok": false
}
],
"sub": "Carbono 3K · Core EVA · Hecha a mano en España",
"coll": "",
"soldout": false,
"tag": "Control",
"dureza": "Blanda",
"balance": "Medio (26 cm)",
"scores": {
"control": 90,
"manejo": 100,
"potencia": 70,
"dureza": 65,
"dulce": 100
},
"para": "Para jugadores estrategas, que prefieren dominar el partido a buscar el winner. Gran punto dulce y, en pesos bajos (345-355 g), una maravilla si tienes molestias de codo.",
"img_cut": "img__l__head-blanca.webp"
},
{
"h": "all-black",
"t": "All Black",
"k": "pala",
"price": 230.0,
"img": [
"img__p__all-black_0.webp",
"img__p__all-black_1.webp",
"img__p__all-black_2.webp",
"img__p__all-black_3.webp",
"img__p__all-black_4.webp"
],
"v": [
{
"id": 52420509073750,
"t": "Hombre · 355-375 g",
"ok": true
},
{
"id": 52420370530646,
"t": "Mujer · 345-355 g",
"ok": true
}
],
"sub": "Carbono 3K · Core EVA · Hecha a mano en España",
"coll": "",
"soldout": false,
"tag": "Potencia",
"dureza": "Dura",
"balance": "Alto (+26,5 cm)",
"scores": {
"control": 85,
"manejo": 70,
"potencia": 100,
"dureza": 90,
"dulce": 60
},
"para": "Para jugadores ofensivos que quieren más potencia sin perder control. Ligera y no muy cabezona: cómoda desde el primer minuto y no castiga el brazo.",
"img_cut": "img__l__head-allblack.webp"
},
{
"h": "mochila-paletero-white",
"t": "Mochila Paletero White",
"k": "paletero",
"price": 69.0,
"img": [
"img__p__mochila-paletero-white_0.webp",
"img__p__mochila-paletero-white_1.webp",
"img__p__mochila-paletero-white_2.webp",
"img__p__mochila-paletero-white_3.webp",
"img__p__mochila-paletero-white_4.webp",
"img__p__mochila-paletero-white_5.webp",
"img__p__mochila-paletero-white_6.webp",
"img__p__mochila-paletero-white_7.webp"
],
"v": [
{
"id": 55035623014742,
"t": "",
"ok": true
}
],
"sub": "35 L · 9 bolsillos · Impermeable · Hueco térmico para la pala",
"coll": "",
"soldout": false
},
{
"h": "mochila-paletero-negro",
"t": "Mochila Paletero Black",
"k": "paletero",
"price": 69.0,
"img": [
"img__p__mochila-paletero-negro_0.webp",
"img__p__mochila-paletero-negro_1.webp",
"img__p__mochila-paletero-negro_2.webp",
"img__p__mochila-paletero-negro_3.webp",
"img__p__mochila-paletero-negro_4.webp",
"img__p__mochila-paletero-negro_5.webp",
"img__p__mochila-paletero-negro_6.webp",
"img__p__mochila-paletero-negro_7.webp"
],
"v": [
{
"id": 53411276292438,
"t": "",
"ok": true
}
],
"sub": "35 L · 9 bolsillos · Impermeable · Hueco térmico para la pala",
"coll": "",
"soldout": false,
"badge": "Más vendido"
},
{
"h": "zip-navy-legacy",
"t": "Zip Navy Legacy",
"k": "sudadera",
"price": 79.0,
"img": [
"img__p__zip-navy-legacy_0.webp",
"img__p__zip-navy-legacy_1.webp",
"img__p__zip-navy-legacy_2.webp",
"img__p__zip-navy-legacy_3.webp",
"img__p__zip-navy-legacy_4.webp",
"img__p__zip-navy-legacy_5.webp",
"img__p__zip-navy-legacy_6.webp",
"img__p__zip-navy-legacy_7.webp"
],
"v": [
{
"id": 52797799170390,
"t": "XS",
"ok": false
},
{
"id": 52797799203158,
"t": "S",
"ok": true
},
{
"id": 52797799235926,
"t": "M",
"ok": true
},
{
"id": 52797799268694,
"t": "L",
"ok": true
},
{
"id": 52797799301462,
"t": "XL",
"ok": true
},
{
"id": 52797799334230,
"t": "2XL",
"ok": true
},
{
"id": 53062217957718,
"t": "3XL",
"ok": true
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Legacy Starts at Home",
"soldout": false
},
{
"h": "zip-beige-legacy",
"t": "Zip Beige Legacy",
"k": "sudadera",
"price": 79.0,
"img": [
"img__p__zip-beige-legacy_0.webp",
"img__p__zip-beige-legacy_1.webp",
"img__p__zip-beige-legacy_2.webp",
"img__p__zip-beige-legacy_3.webp",
"img__p__zip-beige-legacy_4.webp",
"img__p__zip-beige-legacy_5.webp",
"img__p__zip-beige-legacy_6.webp",
"img__p__zip-beige-legacy_7.webp"
],
"v": [
{
"id": 52797802021206,
"t": "XS",
"ok": false
},
{
"id": 52797802053974,
"t": "S",
"ok": true
},
{
"id": 52797802086742,
"t": "M",
"ok": true
},
{
"id": 52797802119510,
"t": "L",
"ok": true
},
{
"id": 52797802152278,
"t": "XL",
"ok": true
},
{
"id": 52797802185046,
"t": "2XL",
"ok": true
},
{
"id": 53062212419926,
"t": "3XL",
"ok": true
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Legacy Starts at Home",
"soldout": false
},
{
"h": "green-off-court-crewneck",
"t": "Green Off Court Crewneck",
"k": "sudadera",
"price": 77.0,
"img": [
"img__p__green-off-court-crewneck_0.webp",
"img__p__green-off-court-crewneck_1.webp",
"img__p__green-off-court-crewneck_2.webp",
"img__p__green-off-court-crewneck_3.webp",
"img__p__green-off-court-crewneck_4.webp",
"img__p__green-off-court-crewneck_5.webp"
],
"v": [
{
"id": 51974269403478,
"t": "S",
"ok": false
},
{
"id": 51974269436246,
"t": "M",
"ok": false
},
{
"id": 51974269469014,
"t": "L",
"ok": true
},
{
"id": 51974269501782,
"t": "XL",
"ok": false
},
{
"id": 51974269534550,
"t": "XXL",
"ok": true
}
],
"sub": "400 GSM · algodón heavy · Oversize",
"coll": "Off Court",
"soldout": false
},
{
"h": "hoodie-own-your-grind",
"t": "Hoodie Own Your Grind",
"k": "sudadera",
"price": 89.0,
"img": [
"img__p__hoodie-own-your-grind_0.webp",
"img__p__hoodie-own-your-grind_1.webp",
"img__p__hoodie-own-your-grind_2.webp",
"img__p__hoodie-own-your-grind_3.webp",
"img__p__hoodie-own-your-grind_4.webp"
],
"v": [
{
"id": 50152241660246,
"t": "XS",
"ok": true
},
{
"id": 50083102425430,
"t": "S",
"ok": true
},
{
"id": 50083102458198,
"t": "M",
"ok": true
},
{
"id": 50083102490966,
"t": "L",
"ok": false
},
{
"id": 50083102523734,
"t": "XL",
"ok": false
},
{
"id": 50083102556502,
"t": "XXL",
"ok": true
}
],
"sub": "Algodón heavy · Oversize",
"coll": "Own Your Grind",
"soldout": false
},
{
"h": "own-your-grid-grey-melagne-crewneck",
"t": "Own Your Grid Grey Crewneck",
"k": "sudadera",
"price": 74.0,
"img": [
"img__p__own-your-grid-grey-melagne-crewneck_0.webp",
"img__p__own-your-grid-grey-melagne-crewneck_1.webp",
"img__p__own-your-grid-grey-melagne-crewneck_2.webp",
"img__p__own-your-grid-grey-melagne-crewneck_3.webp"
],
"v": [
{
"id": 50055004160342,
"t": "S",
"ok": false
},
{
"id": 50055004193110,
"t": "M",
"ok": false
},
{
"id": 50055004225878,
"t": "L",
"ok": true
},
{
"id": 50055004258646,
"t": "XL",
"ok": true
},
{
"id": 50055004291414,
"t": "XXL",
"ok": false
}
],
"sub": "Algodón heavy · Oversize",
"coll": "Own Your Grid",
"soldout": false
},
{
"h": "la-blanca-copia",
"t": "Own Your Grid Navy Crewneck",
"k": "sudadera",
"price": 74.0,
"img": [
"img__p__la-blanca-copia_0.webp",
"img__p__la-blanca-copia_1.webp",
"img__p__la-blanca-copia_2.webp",
"img__p__la-blanca-copia_3.webp",
"img__p__la-blanca-copia_4.webp",
"img__p__la-blanca-copia_5.webp",
"img__p__la-blanca-copia_6.webp",
"img__p__la-blanca-copia_7.webp"
],
"v": [
{
"id": 50054974996822,
"t": "S",
"ok": false
},
{
"id": 50054975029590,
"t": "M",
"ok": false
},
{
"id": 50054975062358,
"t": "L",
"ok": true
},
{
"id": 50054975095126,
"t": "XL",
"ok": true
},
{
"id": 50054975127894,
"t": "XXL",
"ok": true
}
],
"sub": "",
"coll": "Own Your Grid",
"soldout": false
},
{
"h": "black-coffe-off-court-crewneck",
"t": "Black Coffee Off Court Crewneck",
"k": "sudadera",
"price": 77.0,
"img": [
"img__p__black-coffe-off-court-crewneck_0.webp",
"img__p__black-coffe-off-court-crewneck_1.webp",
"img__p__black-coffe-off-court-crewneck_2.webp",
"img__p__black-coffe-off-court-crewneck_3.webp",
"img__p__black-coffe-off-court-crewneck_4.webp"
],
"v": [
{
"id": 51974295322966,
"t": "S",
"ok": false
},
{
"id": 51974295355734,
"t": "M",
"ok": false
},
{
"id": 51974295388502,
"t": "L",
"ok": false
},
{
"id": 51974295421270,
"t": "XL",
"ok": false
},
{
"id": 51974295454038,
"t": "XXL",
"ok": false
}
],
"sub": "400 GSM · algodón heavy · Oversize",
"coll": "Off Court",
"soldout": true
},
{
"h": "bien-jugado-burgundy-polo",
"t": "Bien Jugado Burgundy Polo",
"k": "polo",
"price": 67.0,
"img": [
"img__p__bien-jugado-burgundy-polo_0.webp",
"img__p__bien-jugado-burgundy-polo_1.webp",
"img__p__bien-jugado-burgundy-polo_2.webp",
"img__p__bien-jugado-burgundy-polo_3.webp"
],
"v": [
{
"id": 51015890370902,
"t": "S",
"ok": true
},
{
"id": 51015890403670,
"t": "M",
"ok": true
},
{
"id": 51015890436438,
"t": "L",
"ok": false
},
{
"id": 51015890469206,
"t": "XL",
"ok": true
},
{
"id": 51015890501974,
"t": "XXL",
"ok": true
}
],
"sub": "240 GSM · algodón premium interlock",
"coll": "Bien Jugado",
"soldout": false
},
{
"h": "bien-jugado-green-polo",
"t": "Bien Jugado Green Polo",
"k": "polo",
"price": 67.0,
"img": [
"img__p__bien-jugado-green-polo_0.webp",
"img__p__bien-jugado-green-polo_1.webp",
"img__p__bien-jugado-green-polo_2.webp",
"img__p__bien-jugado-green-polo_3.webp"
],
"v": [
{
"id": 51015849509206,
"t": "S",
"ok": true
},
{
"id": 51015849541974,
"t": "M",
"ok": true
},
{
"id": 51015849574742,
"t": "L",
"ok": true
},
{
"id": 51015849607510,
"t": "XL",
"ok": true
},
{
"id": 51015849640278,
"t": "XXL",
"ok": true
}
],
"sub": "240 GSM · algodón premium interlock",
"coll": "Bien Jugado",
"soldout": false
},
{
"h": "bien-jugado-navy-polo",
"t": "Bien Jugado Navy Polo",
"k": "polo",
"price": 67.0,
"img": [
"img__p__bien-jugado-navy-polo_0.webp",
"img__p__bien-jugado-navy-polo_1.webp",
"img__p__bien-jugado-navy-polo_2.webp",
"img__p__bien-jugado-navy-polo_3.webp"
],
"v": [
{
"id": 51015834566998,
"t": "S",
"ok": true
},
{
"id": 51015834599766,
"t": "M",
"ok": true
},
{
"id": 51015834632534,
"t": "L",
"ok": true
},
{
"id": 51015834665302,
"t": "XL",
"ok": true
},
{
"id": 51015834698070,
"t": "XXL",
"ok": true
}
],
"sub": "240 GSM · algodón premium interlock",
"coll": "Bien Jugado",
"soldout": false
},
{
"h": "legacy-white-tee",
"t": "Legacy White Tee",
"k": "camiseta",
"price": 49.0,
"img": [
"img__p__legacy-white-tee_0.webp",
"img__p__legacy-white-tee_1.webp",
"img__p__legacy-white-tee_2.webp",
"img__p__legacy-white-tee_3.webp",
"img__p__legacy-white-tee_4.webp",
"img__p__legacy-white-tee_5.webp",
"img__p__legacy-white-tee_6.webp",
"img__p__legacy-white-tee_7.webp"
],
"v": [
{
"id": 52797793829206,
"t": "XS",
"ok": true
},
{
"id": 52797793861974,
"t": "S",
"ok": true
},
{
"id": 52797793894742,
"t": "M",
"ok": true
},
{
"id": 52797793927510,
"t": "L",
"ok": true
},
{
"id": 52797793960278,
"t": "XL",
"ok": true
},
{
"id": 54128397386070,
"t": "XXL",
"ok": true
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Legacy Starts at Home",
"soldout": false
},
{
"h": "legacy-navy-tee",
"t": "Legacy Navy Tee",
"k": "camiseta",
"price": 49.0,
"img": [
"img__p__legacy-navy-tee_0.webp",
"img__p__legacy-navy-tee_1.webp",
"img__p__legacy-navy-tee_2.webp",
"img__p__legacy-navy-tee_3.webp",
"img__p__legacy-navy-tee_4.webp",
"img__p__legacy-navy-tee_5.webp",
"img__p__legacy-navy-tee_6.webp",
"img__p__legacy-navy-tee_7.webp"
],
"v": [
{
"id": 52797789700438,
"t": "XS",
"ok": true
},
{
"id": 52797789733206,
"t": "S",
"ok": true
},
{
"id": 52797789765974,
"t": "M",
"ok": true
},
{
"id": 52797789798742,
"t": "L",
"ok": false
},
{
"id": 52797789831510,
"t": "XL",
"ok": true
},
{
"id": 52797789864278,
"t": "2XL",
"ok": true
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Legacy Starts at Home",
"soldout": false
},
{
"h": "fuchsia-ltd-apparel-tee",
"t": "Fuchsia LTD Apparel Tee",
"k": "camiseta",
"price": 52.0,
"img": [
"img__p__fuchsia-ltd-apparel-tee_0.webp",
"img__p__fuchsia-ltd-apparel-tee_1.webp",
"img__p__fuchsia-ltd-apparel-tee_2.webp",
"img__p__fuchsia-ltd-apparel-tee_3.webp"
],
"v": [
{
"id": 54081575453014,
"t": "XS",
"ok": true
},
{
"id": 52043632738646,
"t": "S",
"ok": true
},
{
"id": 52043632771414,
"t": "M",
"ok": false
},
{
"id": 52043632804182,
"t": "L",
"ok": true
},
{
"id": 52043632836950,
"t": "XL",
"ok": true
},
{
"id": 52043632869718,
"t": "XXL",
"ok": true
}
],
"sub": "185 GSM · algodón lavado · Oversize",
"coll": "LTD Apparel",
"soldout": false
},
{
"h": "black-ltd-apparel-tee",
"t": "Black LTD Apparel Tee",
"k": "camiseta",
"price": 52.0,
"img": [
"img__p__black-ltd-apparel-tee_0.webp",
"img__p__black-ltd-apparel-tee_1.webp",
"img__p__black-ltd-apparel-tee_2.webp",
"img__p__black-ltd-apparel-tee_3.webp",
"img__p__black-ltd-apparel-tee_4.webp",
"img__p__black-ltd-apparel-tee_5.webp"
],
"v": [
{
"id": 54101558755670,
"t": "XS",
"ok": true
},
{
"id": 51973794201942,
"t": "S",
"ok": true
},
{
"id": 51973794234710,
"t": "M",
"ok": false
},
{
"id": 51973794267478,
"t": "L",
"ok": true
},
{
"id": 51973794300246,
"t": "XL",
"ok": true
},
{
"id": 51973794333014,
"t": "XXL",
"ok": false
}
],
"sub": "185 GSM · algodón lavado · Oversize",
"coll": "LTD Apparel",
"soldout": false
},
{
"h": "ltd-apparel",
"t": "White LTD Apparel Tee",
"k": "camiseta",
"price": 52.0,
"img": [
"img__p__ltd-apparel_0.webp",
"img__p__ltd-apparel_1.webp",
"img__p__ltd-apparel_2.webp",
"img__p__ltd-apparel_3.webp",
"img__p__ltd-apparel_4.webp"
],
"v": [
{
"id": 54101548695894,
"t": "XS",
"ok": true
},
{
"id": 51971054764374,
"t": "S",
"ok": true
},
{
"id": 51971054797142,
"t": "M",
"ok": true
},
{
"id": 51971054829910,
"t": "L",
"ok": true
},
{
"id": 51971054862678,
"t": "XL",
"ok": true
},
{
"id": 51971054895446,
"t": "XXL",
"ok": true
}
],
"sub": "185 GSM · algodón lavado · Oversize",
"coll": "LTD Apparel",
"soldout": false
},
{
"h": "sunday-secco-club-yelow-tee",
"t": "Sunday Secco Club Yellow Tee",
"k": "camiseta",
"price": 47.0,
"img": [
"img__p__sunday-secco-club-yelow-tee_0.webp",
"img__p__sunday-secco-club-yelow-tee_1.webp",
"img__p__sunday-secco-club-yelow-tee_2.webp",
"img__p__sunday-secco-club-yelow-tee_3.webp",
"img__p__sunday-secco-club-yelow-tee_4.webp"
],
"v": [
{
"id": 51015820476758,
"t": "S",
"ok": true
},
{
"id": 51015820509526,
"t": "M",
"ok": false
},
{
"id": 51015820542294,
"t": "L",
"ok": true
},
{
"id": 51015820575062,
"t": "XL",
"ok": true
},
{
"id": 51015820607830,
"t": "XXL",
"ok": false
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Sunday Secco Club",
"soldout": false
},
{
"h": "sunday-padel-club-lima-tee",
"t": "Sunday Secco Club Lima Tee",
"k": "camiseta",
"price": 47.0,
"img": [
"img__p__sunday-padel-club-lima-tee_0.webp",
"img__p__sunday-padel-club-lima-tee_1.webp",
"img__p__sunday-padel-club-lima-tee_2.webp",
"img__p__sunday-padel-club-lima-tee_3.webp"
],
"v": [
{
"id": 51015805862230,
"t": "S",
"ok": true
},
{
"id": 51015805894998,
"t": "M",
"ok": true
},
{
"id": 51015805927766,
"t": "L",
"ok": true
},
{
"id": 51015805960534,
"t": "XL",
"ok": true
},
{
"id": 51015805993302,
"t": "XXL",
"ok": false
}
],
"sub": "185 GSM · 100 % algodón · Oversize",
"coll": "Sunday Secco Club",
"soldout": false
},
{
"h": "athletic-social-club-black-tee",
"t": "Athletic Social Club Black Tee",
"k": "camiseta",
"price": 49.0,
"img": [
"img__p__athletic-social-club-black-tee_0.webp",
"img__p__athletic-social-club-black-tee_1.webp",
"img__p__athletic-social-club-black-tee_2.webp",
"img__p__athletic-social-club-black-tee_3.webp",
"img__p__athletic-social-club-black-tee_4.webp"
],
"v": [
{
"id": 54101532770646,
"t": "XS",
"ok": true
},
{
"id": 50077678731606,
"t": "S",
"ok": true
},
{
"id": 50077678764374,
"t": "M",
"ok": true
},
{
"id": 50077678797142,
"t": "L",
"ok": true
},
{
"id": 50077678829910,
"t": "XL",
"ok": true
},
{
"id": 50077678862678,
"t": "XXL",
"ok": true
}
],
"sub": "185 GSM · algodón orgánico · Oversize",
"coll": "Athletic Social Club",
"soldout": false
},
{
"h": "athletic-social-club-white",
"t": "Athletic Social Club White Tee",
"k": "camiseta",
"price": 47.0,
"img": [
"img__p__athletic-social-club-white_0.webp",
"img__p__athletic-social-club-white_1.webp",
"img__p__athletic-social-club-white_2.webp",
"img__p__athletic-social-club-white_3.webp",
"img__p__athletic-social-club-white_4.webp"
],
"v": [
{
"id": 54101542863190,
"t": "XS",
"ok": false
},
{
"id": 50066571133270,
"t": "S",
"ok": true
},
{
"id": 50066571166038,
"t": "M",
"ok": true
},
{
"id": 50066571198806,
"t": "L",
"ok": false
},
{
"id": 50066571231574,
"t": "XL",
"ok": true
},
{
"id": 50066571264342,
"t": "XXL",
"ok": false
}
],
"sub": "185 GSM · algodón orgánico · Oversize",
"coll": "Athletic Social Club",
"soldout": false
}
];
